__turbopack_context__.v({
  "backgroundVideo": "style-module-scss-module__gsLM4a__backgroundVideo",
  "container": "style-module-scss-module__gsLM4a__container",
  "header": "style-module-scss-module__gsLM4a__header",
  "logo": "style-module-scss-module__gsLM4a__logo",
  "logoSubtext": "style-module-scss-module__gsLM4a__logoSubtext",
  "logoText": "style-module-scss-module__gsLM4a__logoText",
  "metricItem": "style-module-scss-module__gsLM4a__metricItem",
  "metricLabel": "style-module-scss-module__gsLM4a__metricLabel",
  "metricValue": "style-module-scss-module__gsLM4a__metricValue",
  "metricsGrid": "style-module-scss-module__gsLM4a__metricsGrid",
  "metricsSection": "style-module-scss-module__gsLM4a__metricsSection",
  "scrollContainer": "style-module-scss-module__gsLM4a__scrollContainer",
  "scrollContent": "style-module-scss-module__gsLM4a__scrollContent",
  "videoOverlay": "style-module-scss-module__gsLM4a__videoOverlay",
});
